import React, { useEffect, useState } from "react";
import { ArrowUpRight, Phone, MapPin } from "lucide-react";
import { clinicInfo } from "../mock";

/**
 * Floating "Book on HotDoc" + Call + Directions buttons visible on mobile only.
 * Fades in after the user scrolls a little way down the page.
 */
export default function FloatingBook() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="mobile-floating-cta"
      className={`lg:hidden fixed bottom-4 left-4 right-4 z-40 flex items-center gap-2 transition-all duration-300 ${
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-6 pointer-events-none"
      }`}
    >
      <a
        href={`tel:${clinicInfo.phoneRaw}`}
        data-testid="mobile-call-btn"
        aria-label="Call reception"
        className="shrink-0 w-14 h-14 rounded-full bg-white text-[#1a2464] shadow-xl grid place-items-center border border-[#eee6f7] active:scale-95 transition-transform"
      >
        <Phone className="w-5 h-5" />
      </a>
      <a
        href={clinicInfo.mapDirections}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-directions-btn"
        aria-label="Get directions"
        className="shrink-0 w-14 h-14 rounded-full bg-white text-[#1a2464] shadow-xl grid place-items-center border border-[#eee6f7] active:scale-95 transition-transform"
      >
        <MapPin className="w-5 h-5" />
      </a>
      <a
        href={clinicInfo.hotdocUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-book-btn"
        className="group flex-1 flex items-center justify-center gap-2 bg-[#1a2464] text-white font-semibold py-4 rounded-full shadow-xl active:scale-[0.98] transition-transform"
      >
        <span>Book on HotDoc</span>
        <span className="w-8 h-8 rounded-full bg-[#3dc9b3] grid place-items-center">
          <ArrowUpRight className="w-4 h-4 text-white" />
        </span>
      </a>
    </div>
  );
}
